export const INITIAL_LOAD_SUCCESS = 'INITIAL_LOAD_SUCCESS';
export const ZONE_SELECT = 'ZONE_SELECT';
export const LOAD_TEMPLATE_ON_SELECT = 'LOAD_TEMPLATE_ON_SELECT';